/**
 * Floating Action Button modules
 */
export * from './floating-action-button';
